var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("PCアプリ リンク")]),_c('CDataTable',{attrs:{"hover":"","bordered":"","fixed":"","items":_vm.apps,"fields":_vm.appsFields},scopedSlots:_vm._u([{key:"releaseDate",fn:function(ref){
var app = ref.item;
return [_c('td',[_vm._v(_vm._s(_vm.displayIsoDate(app.releaseDate)))])]}},{key:"link",fn:function(ref){
var app = ref.item;
return [_c('td',[_c('CButton',{attrs:{"color":"info","href":app.link,"size":"sm","disabled":app.disabled}},[_vm._v("ダウンロード")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }